// @ts-expect-error Plotly untyped
import Plotly from 'plotly.js-cartesian-dist-min';
export { Plotly };
